import throttle from 'lodash/throttle'
import { applyMiddleware, createStore } from 'redux'
import {
  composeWithDevTools as compose,
} from 'redux-devtools-extension/developmentOnly'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'

import { loadState, saveState } from './localStorage'
import reducer from './reducer'

const configureMiddleware = (log) => {
  if (!log) {
    return applyMiddleware(thunk)
  }
  const logger = createLogger()
  return applyMiddleware(thunk, logger)
}

const configureStore = (config = { log: true }) => {
  const persistedState = loadState()
  const store = createStore(
    reducer,
    persistedState,
    compose(configureMiddleware(config.log))
  )
  store.subscribe(throttle(() => {
    saveState(store.getState())
  }, 1000))
  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/state/configureStore.js